export const GOOGLE_MAP_URL = 'https://www.google.com/maps/search/?api=1&query=';
export const SAVE_PROPERTY_URL = '/loyalty/myAccount/saveProperties.mi';
